const firebaseConfig = {
    apiKey: "AIzaSyDENwwAwQAVR4eA7Vb6ccf_mYOgGLhvMVc",
    authDomain: "ema-john-993b5.firebaseapp.com",
    databaseURL: "https://ema-john-993b5.firebaseio.com",
    projectId: "ema-john-993b5",
    storageBucket: "ema-john-993b5.appspot.com",
    messagingSenderId: "775804651498",
    appId: "1:775804651498:web:7a91fdcae242a9d8085493"
  };

  export default firebaseConfig;